module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/img/power-phone-4.ed5912ee.jpg";